import { render, staticRenderFns } from "./groupArticle.module.vue?vue&type=template&id=41f43938&scoped=true"
import script from "./groupArticle.module.vue?vue&type=script&lang=js"
export * from "./groupArticle.module.vue?vue&type=script&lang=js"
import style0 from "./groupArticle.module.vue?vue&type=style&index=0&id=41f43938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f43938",
  null
  
)

export default component.exports